/* Larmenno: logo list as a continuous, slow auto-scrolling marquee (replaces the manual swiper). */
(() => {
  const SPEED = 30; // pixels per second - lower = slower

  const CSS = `
.logo-list--marquee .logo-list__buttons{display:none!important}
.logo-list--marquee .logo-list__content{overflow:hidden;position:relative;-webkit-mask-image:linear-gradient(90deg,transparent 0,#000 8%,#000 92%,transparent 100%);mask-image:linear-gradient(90deg,transparent 0,#000 8%,#000 92%,transparent 100%)}
.logo-list--marquee .logo-list__content::before,.logo-list--marquee .logo-list__content::after{display:none}
.logo-list--marquee .logo-list__wrapper{display:flex;flex-wrap:nowrap;width:max-content;animation:larmenno-logo-marquee var(--marquee-duration,30s) linear infinite;will-change:transform}
.logo-list--marquee .logo-list__content:hover .logo-list__wrapper{animation-play-state:paused}
.logo-list--marquee .logo-list__item,.logo-list--marquee .logo-list__item:first-child,.logo-list--marquee .logo-list__item:last-child{flex-shrink:0;padding:0 2rem;opacity:1!important;transform:none!important}
@media screen and (min-width:576px){.logo-list--marquee .logo-list__item,.logo-list--marquee .logo-list__item:first-child,.logo-list--marquee .logo-list__item:last-child{padding:0 3.2rem}}
@media screen and (min-width:1200px){.logo-list--marquee .logo-list__item,.logo-list--marquee .logo-list__item:first-child,.logo-list--marquee .logo-list__item:last-child{padding:0 5rem}}
@keyframes larmenno-logo-marquee{from{transform:translate3d(0,0,0)}to{transform:translate3d(-50%,0,0)}}
`;

  const addStyles = () => {
    if (document.getElementById('larmenno-logo-marquee-css')) return;
    const style = document.createElement('style');
    style.id = 'larmenno-logo-marquee-css';
    style.textContent = CSS;
    document.head.appendChild(style);
  };

  const makeClone = (node) => {
    const clone = node.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    clone.removeAttribute('data-shopify-editor-block');
    clone.querySelectorAll('img').forEach((img) => img.setAttribute('loading', 'eager'));
    return clone;
  };

  const init = (section) => {
    if (!section || !section.classList || !section.classList.contains('section-logo-list')) return;
    const list = section.querySelector('.logo-list');
    const wrapper = section.querySelector('.logo-list__wrapper');
    if (!list || !wrapper || wrapper.dataset.marquee === 'true') return;

    const originals = Array.from(wrapper.children).filter((el) => el.classList.contains('logo-list__item'));
    if (!originals.length) return;

    addStyles();
    wrapper.dataset.marquee = 'true';
    list.classList.add('logo-list--marquee');

    const content = wrapper.parentElement;
    const viewport = (content && content.clientWidth) || window.innerWidth;
    const setWidth = Math.max(wrapper.scrollWidth, 1);

    // Repeat the logos until one set is at least as wide as the screen
    const repeats = Math.max(1, Math.ceil(viewport / setWidth));
    for (let i = 1; i < repeats; i++) {
      originals.forEach((item) => wrapper.appendChild(makeClone(item)));
    }

    // Duplicate the full set once so the loop is seamless
    Array.from(wrapper.children).forEach((item) => wrapper.appendChild(makeClone(item)));

    const setDuration = () => {
      const halfWidth = wrapper.scrollWidth / 2;
      const seconds = Math.max(10, halfWidth / SPEED);
      wrapper.style.setProperty('--marquee-duration', seconds + 's');
    };
    setDuration();
    window.addEventListener('load', setDuration);
  };

  const start = (section) => {
    if (!section) return;
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init(section));
    } else {
      requestAnimationFrame(() => init(section));
    }
  };

  start(document.currentScript && document.currentScript.parentElement);
  document.addEventListener('shopify:section:load', (e) => start(e.target));
})();
